export { NAVS_MVT, MAP_ALL_ATTRS_MVT }
const MAP_ATTRS_MVT = {
	id:'ATTRS_MVT',
	navLabel:'sidenav.movement.label',
	navIcon:'exchange',
	instancesClass:{
		mvttypemvt:{
			iconClass: 'bar-chart',
			attrsList: [
				{attrName: 'typeMvtName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'typeMvtCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		mvttypedep:{
			iconClass: 'barcode',
			attrsList: [
				{attrName: 'typeDepName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'typeDepCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		},
		mvtbank:{
			iconClass: 'bank',
			attrsList: [
				{attrName: 'bankName', attrCol: '30%', searchable: true, sortable: true},
				{attrName: 'bankCode', attrCol: '20%', searchable: true, sortable: true},
				{attrName: 'dateCreated', attrCol: '15%', searchable: false, sortable: true},
				{attrName: 'lastUpdated', attrCol: '15%', searchable: false, sortable: true},
			],
			actCol: {
				actDisplay: true,
				thCol: '20%',
				actAdd: true, 
				actGet: true, 
				actEdit: true, 
				actDel: false
			}
		}

	}
}
const NAVS_MVT = [MAP_ATTRS_MVT]

const MAP_ALL_ATTRS_MVT = {};
for (let key in MAP_ATTRS_MVT.instancesClass) {
	MAP_ALL_ATTRS_MVT[key]= MAP_ATTRS_MVT.instancesClass[key]
}